import { MouseEvent } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../../../ReduxToolkit/Hooks";
import { getColors } from "../../../../../../../Utils/Ecommerce.service";
import { filterColor } from "../../../../../../../ReduxToolkit/Reducers/ECommerce/FilterSlice";
import { Colors } from "../../../../../../../Constants/Constants";
import { H6, LI, UL } from "../../../../../../../AbstractElements";

const ColorsFilter = () => {
  const { productItem } = useAppSelector((state) => state.product);
  const dispatch = useAppDispatch();
  const colors = getColors(productItem);

  const colorHandle = (event: MouseEvent<HTMLLIElement>, color: string) => {
    const elem = document.getElementsByClassName("color-selector")[0].getElementsByTagName("li");
    for (let i = 0; i < elem.length; i++) {
      elem[i].classList.remove("active");
    }
    (event.target as Element).classList.add("active");
    dispatch(filterColor(color));
  };

  return (
    <div className="product-filter slider-product">
      <H6 className="f-w-600">{Colors}</H6>
      <div className="color-selector">
        <UL className="d-flex flex-row gap-1">
          {colors.map((color, i) => (
            <LI className={color} title={color} onClick={(e: MouseEvent<HTMLLIElement, globalThis.MouseEvent>) => colorHandle(e, color)} key={i}></LI>
          ))}
        </UL>
      </div>
    </div>
  );
};

export default ColorsFilter;
